import type { AxiosError, AxiosRequestConfig } from 'axios';
import portfolioAxiosInstance from '@/lib/portfolioAxiosInstance';

/**
 * Orval mutator for Portfolio-tagged endpoints.
 * Uses passcode Bearer auth and portfolio-specific 401 handling.
 */
export const portfolioCustomInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  return portfolioAxiosInstance({
    ...config,
    ...options,
  }).then(({ data }) => data);
};

export type ErrorType<Error> = AxiosError<Error>;
export type BodyType<BodyData> = BodyData;
